import React from 'react';
import styled from 'styled-components';
import { itvThemeColor, themeColor } from '../../Theming';
import ItvSquareLogo from '../../ITVActivation/Logos/ItvSquareLogo';
import { Trans } from 'react-i18next';

const Container = styled.div`
  padding-top: 24px;
  padding-bottom: 20px;
  background-color: ${itvThemeColor('greenishBlue')};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 400px;
`;

const LogoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.span`
  color: ${themeColor('white')};
  font-weight: Bold;
  font-family: Arial;
  padding-block: 16px;
  text-align: center;
  line-height: 25px;
  font-size: 20px;
`;

const DisclaimerContainer = styled.div`
  background-color: ${themeColor('white')};
  margin-inline: 24px;
  border-radius: 10px;
  padding: 10px;
  overflow: auto;
  flex-grow: 1;
`;

const Disclaimer = styled.span`
  font-family: Arial;
  font-size: 13px;
  line-height: 18px;
  color: ${themeColor('black')};
`;

interface HeaderProps {
  title: string;
  permissionsAgreed?: boolean;
  disclaimerText?: string;
}

const Header: React.FC<HeaderProps> = ({
  title,
  permissionsAgreed,
  disclaimerText,
}) => {
  return (
    <Container>
      <LogoTextContainer>
        <ItvSquareLogo height={60} />
        <Trans>
          <Title>{title}</Title>
        </Trans>
      </LogoTextContainer>
      {!permissionsAgreed && (
        <DisclaimerContainer>
          <Disclaimer>{disclaimerText}</Disclaimer>
        </DisclaimerContainer>
      )}
    </Container>
  );
};

export default Header;
